// Data-row visual pieces (progress/split bars and the big-number stat) for the Territory Overview panels.
import { Box, Typography } from "@mui/material";

import { BODY, MUTED, PRIMARY_BLUE, TRACK_BG } from "./tokens";

export function ProductSplitBar({ split }) {
  return (
    <Box sx={{ mb: 1.5, "&:last-child": { mb: 0 } }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.75,
          gap: 1,
        }}
      >
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: BODY }}>
          {split.label}
        </Typography>
        <Typography sx={{ fontSize: 12, color: MUTED }}>
          {split.segments.map((s) => `${s.name} ${s.value}%`).join(" / ")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          height: 13,
          borderRadius: 999,
          overflow: "hidden",
          bgcolor: TRACK_BG,
        }}
      >
        {split.segments.map((s) => (
          <Box
            key={s.name}
            sx={{
              width: `${s.value}%`,
              height: "100%",
              bgcolor: s.color,
            }}
          />
        ))}
      </Box>
    </Box>
  );
}

export function AttainmentBar({ product }) {
  const pct = product.goal
    ? Math.round((product.current / product.goal) * 100)
    : 0;
  const widthPct = Math.min(100, Math.max(0, pct));

  return (
    <Box sx={{ mb: 1.75, "&:last-child": { mb: 0 } }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.75,
          gap: 1,
        }}
      >
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: BODY }}>
          {product.name}
        </Typography>
        <Typography sx={{ fontSize: 12, color: MUTED }}>
          {product.current} / {product.goal} ({pct}%)
        </Typography>
      </Box>
      <Box
        sx={{
          height: 13,
          borderRadius: 999,
          bgcolor: TRACK_BG,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${widthPct}%`,
            bgcolor: product.color || PRIMARY_BLUE,
            borderRadius: 999,
          }}
        />
      </Box>
    </Box>
  );
}

// Big number + label used by the Active Patients QTD panel; one per product line returned for the rep's alignment (Tyvaso for CPS/ALD, Orenitram/Remodulin for ROCS, or all of them for national/leadership) — no product is hard-coded here.
export function ActivePatientStat({ stat }) {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 32,
          fontWeight: 700,
          lineHeight: 1,
          color: stat.color || PRIMARY_BLUE,
        }}
      >
        {stat.count}
      </Typography>
      <Typography sx={{ mt: 0.5, fontSize: 13, fontWeight: 600, color: BODY }}>
        {stat.product} Active Patients
      </Typography>
    </Box>
  );
}
